import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
  from,
} from '@apollo/client';

import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { BACKEND_URL } from '../../shared/contants';
import { OnTokenEvent } from '../auth/auth-events';


const httpLink = createHttpLink({
  uri: `${BACKEND_URL}/graphql`,
});



const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export function createApolloClient(): ApolloClient<NormalizedCacheObject> {
  const authLink = setContext((_, { headers }) => {
    // get the authentication token from event storage if it exists
    // return the headers to the context so httpLink can read them
    const token = OnTokenEvent.get()?.token;

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  });

  const link = from([authLink, errorLink, httpLink]);

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
}

